import { addNavMenuItem, registerFormInputComponent } from '@vendure/admin-ui/core';
import { CloverCustomerIdFormComponent } from './clover-customer-id/clover-customer-id.component';

export default [
    registerFormInputComponent('clover-customers-id-input', CloverCustomerIdFormComponent),
    addNavMenuItem(
        {
            id: 'clover-orders',
            label: 'Clover POS Orders',
            routerLink: ['/extensions/sales/clover-orders'],
            icon: 'cloud-network',
        },
        'sales',
    ),
];
